export const TAX_SEARCH_TYPE = {
  MST: 'MST',
  CCCD: 'CCCD'
}

export const TAX_SEARCH_TYPE_OPTIONS = [
  {
    value: TAX_SEARCH_TYPE.MST,
    label: 'Mã số thuế',
    placeholder: 'Nhập mã số thuế',
    maxLength: 13
  },
  {
    value: TAX_SEARCH_TYPE.CCCD,
    label: 'CCCD',
    placeholder: 'Nhập số CCCD',
    maxLength: 12
  }
]

export const normalizeTaxKeyword = (value) => {
  return String(value || '').replace(/\D/g, '')
}

export const validateTaxKeyword = ({ searchType, keyword }) => {
  const searchKeyword = normalizeTaxKeyword(keyword)

  if (!searchKeyword) return 'Vui lòng nhập thông tin tra cứu'

  if (searchKeyword.length > 15) {
    return 'Thông tin tra cứu không được vượt quá 15 số'
  }

  if (
    searchType === TAX_SEARCH_TYPE.MST &&
    (searchKeyword.length < 10 || searchKeyword.length > 13)
  ) {
    return 'Mã số thuế phải có từ 10 đến 13 số'
  }

  if (searchType === TAX_SEARCH_TYPE.CCCD && searchKeyword.length !== 12) {
    return 'CCCD phải có 12 số'
  }

  return ''
}